/**
 * Unwraps a CommonJS module that sets `exports.default`.
 *
 * Vite's dependency optimizer emits `export default require_thing()` for such
 * packages, so a default import receives the whole exports object
 * (`{__esModule: true, default: ...}`) rather than the value itself. Rendering
 * that object gives React's "Element type is invalid ... but got: object".
 *
 * Only needed for packages with no usable named export -- prefer importing the
 * name directly where the package offers one.
 */
export function cjsDefault<T>(mod: T): T {
    const candidate = mod as unknown as {__esModule?: boolean; default?: T};
    return candidate && candidate.__esModule && candidate.default ? candidate.default : mod;
}
